import { ThemeConfig } from 'antd'

export const LARGE_SCALE_THEME: ThemeConfig = {
    token: {
        fontSize: 16,
    },
    components: {
        Table: {
            cellFontSize: 16,
        },
    },
}
